import slugify from 'slugify';

export default {
  async addProductToCart({ commit, state }, { product, count, listName }) {
    try {
      if (state.requestSource) {
        state.requestSource.cancel();
      }
      commit('setRequestSource', this.$axios.CancelToken.source());

      let apiUrl = `${this.$config.baseOfixApi}/e-commerce/v1/shopping-carts/current`;

      if (state.editOrderId) {
        apiUrl = `${this.$config.baseOfixApi}/e-commerce/v1/sales-orders/${state.editOrderId}/item`;
      }

      const {
        data: { shoppingCart, order },
      } = await this.$axios
        .post(
          apiUrl,
          {
            productId: product.id,
            quantity: count,
          },
          {
            cancelToken: state.requestSource.token,
          },
        )
        .then(data => {
          if (!state.editOrderId) {
            const categories = product.category.namesInPath.reduce((acc, curr, index) => {
              acc['category' + (index === 0 ? '' : index + 1)] = curr;
              return acc;
            }, {});

            this.$gtm.push({ ecommerce: null });
            this.$gtm.push({
              event: 'add_to_cart',
              ecommerce: {
                currency: 'PLN',
                value: count * product.priceObject.gross,
                items: [
                  {
                    item_id: product.id,
                    item_name: product.name,
                    discount: product.priceBeforeDiscountObject
                      ? this.$helper.calculateDiscount(
                          product.priceBeforeDiscountObject.gross,
                          product.priceObject.gross,
                        )
                      : 0,
                    brand: product.brand ? product.brand.name : '',
                    ...categories,
                    item_list_id: listName ? slugify(listName) : '',
                    item_list_name: listName || '',
                    promotion_id: product?.promotion?.id ?? '',
                    promotion_name: product?.promotion?.name ?? '',
                    price: product.priceObject.gross,
                    variant: '',
                    quantity: count,
                  },
                ],
              },
            });
          }

          return data;
        });

      if (!state.editOrderId) {
        this.$toast.success(
          `<div class="popupToast__content"><b>${this.$helper.shortText(
            product.name,
            40,
          )}</b><br />Został dodany do koszyka</div>`,
          {
            theme: 'popupToast__inner',
            containerClass: 'popupToast__container',
            keepOnHover: true,
            duration: 4000,
            action: [
              {
                text: 'Zobacz',
                onClick: (e, toastObject) => {
                  this.$router.push(this.app.localePath({ name: 'cart' }));
                  toastObject.goAway(0);
                },
              },
              {
                class: 'popupToast__close',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
            ],
          },
        );
        commit('setCart', shoppingCart);
      } else {
        this.$toast.success(
          `<div class="popupToast__content"><b>${this.$helper.shortText(
            product.name,
            40,
          )}</b><br />Zamówienie zostało zaktualizowane</div>`,
          {
            theme: 'popupToast__inner',
            containerClass: 'popupToast__container',
            keepOnHover: true,
            duration: 4000,
            action: [
              {
                text: 'Zobacz',
                onClick: (e, toastObject) => {
                  this.$router.push(
                    this.localePath({
                      name: 'dashboard-orders-slug',
                      params: { slug: state.editOrderId },
                    }),
                  );
                  toastObject.goAway(0);
                },
              },
              {
                class: 'popupToast__close',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
            ],
          },
        );
        const copyOrder = { ...order };
        copyOrder.items = order.itemsWithPacks;
        commit('setOrderCart', copyOrder);
      }
    } catch (e) {
      if (e?.response?.data?.message) {
        this.$toast.error(
          `<div class="popupToast__content"><b>${this.$helper.shortText(
            product.name,
            40,
          )}</b><br />${e.response.data.message}</div>`,
          {
            theme: 'popupToast__inner',
            containerClass: 'popupToast__container',
            keepOnHover: true,
            duration: 4000,
            action: [
              {
                class: 'popupToast__close',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
            ],
          },
        );
      } else if (!state.requestSource) {
        this.$toast.error(
          `<div class="popupToast__content"><b>${this.$helper.shortText(
            product.name,
            40,
          )}</b><br />Nie można dodać do koszyka</div>`,
          {
            theme: 'popupToast__inner',
            containerClass: 'popupToast__container',
            keepOnHover: true,
            duration: 4000,
            action: [
              {
                class: 'popupToast__close',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
            ],
          },
        );
      }
    }
  },
  async addProductsToCart({ commit, state }, { products }) {
    try {
      if (state.requestSource) {
        state.requestSource.cancel();
      }
      commit('setRequestSource', this.$axios.CancelToken.source());

      const apiUrl = `${this.$config.baseOfixApi}/e-commerce/v1/shopping-carts/current/items`;

      const {
        data: { shoppingCart },
      } = await this.$axios
        .post(
          apiUrl,
          {
            items: products,
          },
          {
            cancelToken: state.requestSource.token,
          },
        )
        .then(data => {
          return data;
        });

      this.$toast.success(
        `<div class="popupToast__content">Produkty zostały dodane do koszyka</div>`,
        {
          theme: 'popupToast__inner',
          containerClass: 'popupToast__container',
          keepOnHover: true,
          duration: 4000,
          action: [
            {
              text: 'Zobacz',
              onClick: (e, toastObject) => {
                this.$router.push(this.app.localePath({ name: 'cart' }));
                toastObject.goAway(0);
              },
            },
            {
              class: 'popupToast__close',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          ],
        },
      );
      commit('setCart', shoppingCart);
    } catch {
      if (!state.requestSource) {
        this.$toast.error(
          `<div class="popupToast__content">Nie można dodać produktów do koszyka</div>`,
          {
            theme: 'popupToast__inner',
            containerClass: 'popupToast__container',
            keepOnHover: true,
            duration: 4000,
            action: [
              {
                class: 'popupToast__close',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
            ],
          },
        );
      }
    }
  },
  async clearBasket({ commit }) {
    try {
      const {
        data: { shoppingCart },
      } = await this.$axios.delete(
        `${this.$config.baseOfixApi}/e-commerce/v1/shopping-carts/current`,
      );
      commit('setCart', shoppingCart);
      this.$toast.success(`<div class="popupToast__content">Koszyk został wyczyszczony</div>`, {
        theme: 'popupToast__inner',
        containerClass: 'popupToast__container',
        keepOnHover: true,
        duration: 4000,
        action: [
          {
            text: 'Zobacz',
            onClick: (e, toastObject) => {
              this.$router.push(this.app.localePath({ name: 'cart' }));
              toastObject.goAway(0);
            },
          },
          {
            class: 'popupToast__close',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        ],
      });
    } catch {
      this.$toast.error(
        `<div class="popupToast__content">Błąd podczas czyszczenia koszyka, spróbuj ponownie.</div>`,
        {
          theme: 'popupToast__inner',
          containerClass: 'popupToast__container',
          keepOnHover: true,
          duration: 4000,
          action: [
            {
              text: 'Zobacz',
              onClick: (e, toastObject) => {
                this.$router.push(this.app.localePath({ name: 'cart' }));
                toastObject.goAway(0);
              },
            },
            {
              class: 'popupToast__close',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          ],
        },
      );
    }
  },
  async deleteProductsFromCart({ commit, state }, productIds) {
    const apiUrl = `${this.$config.baseOfixApi}/e-commerce/v1/shopping-carts/current/items`;

    try {
      const {
        data: { shoppingCart },
      } = await this.$axios.delete(apiUrl, {
        data: {
          productIds,
        },
      });
      commit('setCart', shoppingCart);
      this.$toast.success(
        `<div class="popupToast__content">Produkty zostały usunięte z koszyka</div>`,
        {
          theme: 'popupToast__inner',
          containerClass: 'popupToast__container',
          keepOnHover: true,
          duration: 4000,
          action: [
            {
              class: 'popupToast__close',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          ],
        },
      );
    } catch (e) {
      const message = e?.response?.data?.message
        ? e.response.data.message
        : 'Produkty nie zostały usunięte, spróbuj ponownie';
      this.$toast.error(`${message}`, {
        theme: 'popupToast__inner',
        containerClass: 'popupToast__container',
        keepOnHover: true,
        duration: 4000,
        action: [
          {
            text: 'Zobacz',
            onClick: (e, toastObject) => {
              this.$router.push(this.app.localePath({ name: 'cart' }));
              toastObject.goAway(0);
            },
          },
          {
            class: 'popupToast__close',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        ],
      });
    }
  },
  async deleteProductFromCart({ commit, state }, product, listName) {
    let apiUrl = `${this.$config.baseOfixApi}/e-commerce/v1/shopping-carts/current`;

    if (state.editOrderId) {
      apiUrl = `${this.$config.baseOfixApi}/e-commerce/v1/sales-orders/${state.editOrderId}/item`;
    }
    try {
      const {
        data: { shoppingCart, order },
      } = await this.$axios.delete(apiUrl, {
        data: {
          productId: product.id,
        },
      });
      this.$toast.success(
        `<div class="popupToast__content"><b>${this.$helper.shortText(
          product.name,
          40,
        )}</b><br />Został usunięty z koszyka</div>`,
        {
          theme: 'popupToast__inner',
          containerClass: 'popupToast__container',
          keepOnHover: true,
          duration: 4000,
          action: [
            {
              class: 'popupToast__close',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          ],
        },
      );

      if (!state.editOrderId) {
        const categories = product.category.namesInPath.reduce((acc, curr, index) => {
          acc['category' + (index === 0 ? '' : index + 1)] = curr;
          return acc;
        }, {});

        let totalPrice;

        if (product.total) {
          totalPrice = product.total;
        }

        if (product.totalPrice) {
          totalPrice = product.totalPrice;
        }

        this.$gtm.push({ ecommerce: null });
        this.$gtm.push({
          event: 'remove_from_cart',
          ecommerce: {
            currency: 'PLN',
            value: totalPrice.gross,
            items: [
              {
                item_id: product.id,
                item_name: product.name,
                discount: product.priceBeforeDiscountObject
                  ? this.$helper.calculateDiscount(
                      product.priceBeforeDiscountObject.gross,
                      product.priceObject.gross,
                    )
                  : 0,
                brand: product.brand ? product.brand.name : '',
                ...categories,
                item_list_id: listName ? slugify(listName) : '',
                item_list_name: listName || '',
                promotion_id: product?.promotion?.id ?? '',
                promotion_name: product?.promotion?.name ?? '',
                price: product.priceObject.gross,
                variant: '',
                quantity: product.quantity,
              },
            ],
          },
        });
        commit('setCart', shoppingCart);
      } else {
        const copyOrder = { ...order };
        copyOrder.items = order.itemsWithPacks;
        commit('setOrderCart', copyOrder);
      }
    } catch (e) {
      const message = e?.response?.data?.message
        ? e.response.data.message
        : 'Produkty nie zostały usunięte, spróbuj ponownie';
      this.$toast.error(`<div class="popupToast__content">${message}</div>`, {
        theme: 'popupToast__inner',
        containerClass: 'popupToast__container',
        keepOnHover: true,
        duration: 4000,
        action: [
          {
            text: 'Zobacz',
            onClick: (e, toastObject) => {
              this.$router.push(this.app.localePath({ name: 'cart' }));
              toastObject.goAway(0);
            },
          },
          {
            class: 'popupToast__close',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        ],
      });
    }
  },
  async getCart({ commit, state, rootState }) {
    try {
      let apiUrl = `${this.$config.baseOfixApi}/e-commerce/v1/shopping-carts/current`;
      const deliveryMethod = this.$auth.isLogged()
        ? rootState.checkout.checkoutLoggedForm.deliveryMethod
        : rootState.checkout.checkoutForm.deliveryMethod;

      if (state.editOrderId) {
        apiUrl = `${this.$config.baseOfixApi}/e-commerce/v1/sales-orders/${state.editOrderId}/as-shopping-cart`;
      }

      if (state.editOrderId) {
        const {
          data: { order },
        } = await this.$axios.get(apiUrl);
        const copyOrder = { ...order };
        copyOrder.items = order.itemsWithPacks;
        commit('setOrderCart', copyOrder);
      } else {
        const {
          data: { shoppingCart },
        } = await this.$axios.get(apiUrl, { params: { deliveryMethod } });
        commit('setCart', shoppingCart);
      }
    } catch {}
  },
  async updateProductsAmount({ commit, state }, { product, count, disablePopup, listName }) {
    try {
      if (state.requestSource) {
        state.requestSource.cancel();
      }
      commit('setRequestSource', this.$axios.CancelToken.source());
      let apiUrl = `${this.$config.baseOfixApi}/e-commerce/v1/shopping-carts/current`;

      if (state.editOrderId) {
        apiUrl = `${this.$config.baseOfixApi}/e-commerce/v1/sales-orders/${state.editOrderId}/item`;
      }
      const {
        data: { shoppingCart, order },
      } = await this.$axios
        .patch(
          apiUrl,
          {
            productId: product.id,
            quantity: count,
          },
          {
            cancelToken: state.requestSource.token,
          },
        )
        .then(data => {
          if (!state.editOrderId) {
            const productFromShoppingCart = state.shoppingCart.items.find(
              item => item.id === product.id,
            );
            const categories = product.category.namesInPath.reduce((acc, curr, index) => {
              acc['category' + (index === 0 ? '' : index + 1)] = curr;
              return acc;
            }, {});

            this.$gtm.push({ ecommerce: null });

            this.$gtm.push({
              event: productFromShoppingCart.quantity < count ? 'add_to_cart' : 'remove_from_cart',
              ecommerce: {
                currency: 'PLN',
                value: count * product.priceObject.gross,
                items: [
                  {
                    item_id: product.id,
                    item_name: product.name,
                    discount: product.priceBeforeDiscountObject
                      ? this.$helper.calculateDiscount(
                          product.priceBeforeDiscountObject.gross,
                          product.priceObject.gross,
                        )
                      : 0,
                    brand: product.brand ? product.brand.name : '',
                    ...categories,
                    item_list_id: listName ? slugify(listName) : '',
                    item_list_name: listName || '',
                    promotion_id: product?.promotion?.id ?? '',
                    promotion_name: product?.promotion?.name ?? '',
                    price: product.priceObject.gross,
                    variant: '',
                    quantity:
                      productFromShoppingCart.quantity < count
                        ? count - productFromShoppingCart.quantity
                        : productFromShoppingCart.quantity - count,
                  },
                ],
              },
            });
          }

          return data;
        });

      if (state.editOrderId) {
        const copyOrder = { ...order };
        copyOrder.items = order.itemsWithPacks;
        commit('setOrderCart', copyOrder);
      } else {
        commit('setCart', shoppingCart);
      }
      if (!disablePopup) {
        this.$toast.success(
          `<div class="popupToast__content"><b>${this.$helper.shortText(
            product.name,
            40,
          )}</b><br />Został dodany do koszyka</div>`,
          {
            theme: 'popupToast__inner',
            containerClass: 'popupToast__container',
            keepOnHover: true,
            duration: 4000,
            action: [
              {
                text: 'Zobacz',
                onClick: (e, toastObject) => {
                  this.$router.push(this.app.localePath({ name: 'cart' }));
                  toastObject.goAway(0);
                },
              },
              {
                class: 'popupToast__close',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
            ],
          },
        );
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        this.$toast.error(`<div class="popupToast__content">${error.response.data.message}</div>`, {
          theme: 'popupToast__inner',
          containerClass: 'popupToast__container',
          keepOnHover: true,
          duration: 4000,
          action: [
            {
              class: 'popupToast__close',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          ],
        });
      }
    }
  },
  async updatePromoCode({ commit }, promoCode) {
    const form = new FormData();
    form.append('promoCode', promoCode);
    const {
      data: { shoppingCart, message },
    } = await this.$axios.post(
      `${this.$config.baseOfixApi}/e-commerce/v1/shopping-carts/promo-codes`,
      form,
    );
    commit('setCart', shoppingCart);
    return message;
  },
};
